import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { ShortcutAwareTooltip } from 'common/Prose/utils/ShortcutAwareTooltip'
import { useClearFormattingButton } from 'common/Prose/Toolbar/hooks/useClearFormattingButton'
import { Eraser } from 'blaze-ui/icons'
import { Button } from './Button'

export const ClearFormattingButton = () => {
  const view = useEditorView()
  const clearFormatting = useClearFormattingButton(view)

  return (
    <ShortcutAwareTooltip label="Clear formatting">
      <Button onPress={clearFormatting} aria-label="Clear formatting" icon={Eraser} />
    </ShortcutAwareTooltip>
  )
}
